import { createMuiTheme } from "@material-ui/core";
import white from "@material-ui/core/colors/orange";

export default createMuiTheme({
  palette: {
    primary: white
  }
});
